import Vue from 'vue';
import Vuex from 'vuex';
import researchStore from '@/store-modules/research-store';
import impersonateStore from '@/store-modules/console/impersonate-user';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    learnerFacts: [],
  },
  mutations: {
    onSetLearnerFacts: (state: any, facts: any) => {
      state.learnerFacts = facts;
    },
  },
  actions: {

  },
  modules: {
    researchStore,
    impersonateStore,
  },
});
